import type { LabelTypeConfigMap } from './types';

export const labelTypeConfigMap: LabelTypeConfigMap = {
  newModel: {
    labelText: 'NEW MODEL',
    labelClassName: 'containerNewModelLabel',
  },
  newSubmodel: {
    labelText: 'NEW',
    labelClassName: 'containerNewSubmodelLabel',
  },
  facelift: {
    labelText: 'FACELIFT',
    labelClassName: 'containerFaceliftLabel',
  },
  spotlight: {
    labelText: 'SPOTLIGHT',
    labelClassName: 'containerSpotlightLabel',
  },
  upcoming: {
    labelText: 'UPCOMING',
    labelClassName: 'containerUpcomingLabel',
  },
  sgcmElites: {
    labelText: 'Sgcarmart’s Elites',
    labelClassName: 'containerSgcmEliteLabel',
  },
  readyStocks: {
    labelText: 'READY STOCK',
    labelClassName: 'containerReadyStocksLabel',
  },
};
